<template>
  <div>
    <v-card-title class="titulo headline pa-0 primary--text">
      Rastreie suas compras {{ isDesktop ? complementoTitulo : "" }}
    </v-card-title>

    <v-card-text
      v-if="isMobile"
      class="subtitle-1 pa-0 primary--text"
    >
      {{ complementoTitulo }}
    </v-card-text>
  </div>
</template>

<script>
export default {
  name: 'TituloRastreio',

  data: () => ({
    complementoTitulo: 'de forma rápida e eficiente, sem precisar estar logado para isso.',
  }),

  computed: {
    isDesktop() {
      return this.$vuetify.breakpoint.mdAndUp;
    },

    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
</script>
